export default {
  general: {
    connect: "Connect",
    purchase: "Purchase",
    learn_more: "Learn more",
    email_address: "Email address",
    password: "Password",
    confirm_password: "Confirm password",
    type_password: "Type your password",
    placeholder: "Type your password",
    forgot_password: "Forgot password",
    login: "Login",
    register: "Register",
    name: "Name",
    firstLastName: "First and last name",
    region: "Region",
    select_region: "Select region",
    sweden: "Sweden",
    united_kingdom: "United kingdom",
    yes: "Yes",
    no: "No",
    continue: "Continue",
    cancel: "Cancel",
    okay: "Okay",
    accept_terms: "I accept the terms and conditions",
    phone_number: "Phone number",
    send: "Send",
    read_more: "Read more",
    order_it: "Order it",
    monthly: "Monthly",
    annually: "Annually",
    annual: "Annual",
    save: "Save",
    get_plan: "Get plan",
    logout: "Logout",
    connect_plus: "Connect plus",
    status: "Status",
    payment_method: "Payment method",
    step: "Step",
    address: "Address",
    note: "Note",
    optional: "Optional",
    my_home: "My home",
    is_connected: "Is connected",
    confirm: "Confirm",
    additional_info: "Additional information",
    good: "Good",
    connect_alarm: "Connect alarm",
    not_connected: "Not connected",
    change_account: "Change account",
    connected: "Connected",
    connect_account: "Connect account",
    ajax_hubId: "Ajax Hub ID",
    na: "Not available",
    home_name: "Home name",
    code_word: "Code word",
    home_address: "Home address",
    postcode: "Postcode",
    city: "City",
    your_full_name: "Your full name",
    save_and_cont: "Save & Continue",
    next: "Next",
    back: "Back",
    admin: "Admin",
    add: "Add",
    phone: "Phone",
    email: "Email",
    burglary: "Burglary",
    fire: "Fire",
    fight: "Fight",
    emergency: "Emergency",
    sabotage: "Sabotage",
    tech: "Tech",
    summary: "Summary",
    collaborate: "Collaborate",
    flood: "Flood",
    done: "Done",
    webhook_url: "Webhook URL",
    method: "Method",
    request_body: "Request Body",
    group: "Group",
    groups: "Groups",
    public: "Public",
    locked: "Locked",
    private: "Private",
    members: "Members",
    member: "Member",
    yes: "Yes",
    edit: "Edit",
    delete: "Delete",
    test: "Test",
    safeland_connect: "Safeland Connect",
    subscription: "Subscription",
    service_desc: "Service description",
    total_value: "Total value",
    activation_code: "Activation code",
    oops: "Oops!",
    activate: "Activate",
    new_password: "New password",
    year: "Year",
    years: "Years",
    group_name: "Group name",
    group_type: "Group type",
    undo: "Undo",
    voluntarily: "Voluntarily",
    yes: "Yes",
    no: "No",
    choose: "Choose",
    active: "Active",
    inactive: "Inactive",
    invoice: "Invoice",
    reactivate: "Re-activate",
    ok: "Ok",
    reset_password: "Reset password",
    ajax_account: "Ajax account",
    change_hub: "Change hub",
    select_hub: "Select hub",
    safelands_phone_number: "Safeland’s phone number",
    name_and_surname: "Name and surname",
    remove: "Remove",
    delete: "Delete",
    alarm_triggered: "Alarm triggered",
    alarm_ended: "Alarm ended",
    system_activated: "System activated",
    system_deactivated: "System deactivated",
    night_mode_activated: "Night mode activated",
    smhi: "Smart Home integration",
    test_integration: "Test integration",
    save_and_close: "Save and close",
    ajax_smhi: "AJAX Smart Home integration",
    new_webhook: "New webhook",
    edit_integration: "Edit integration",
    add_new_integration: "Add new integration",
    non_supported_smhi: "Smart Home integration",
    edit_webhook: "Edit webhook",
    alarmSMS: "AlarmSMS",
    about_service: "About the service",
    add: "Add",
    new_alarm_recipient: "New AlarmSMS recipient",
    edit_alarm_recipient: "Edit AlarmSMS recipient",
    showMore: "Show more",
    showLess: "Show less",
    mobile_number: "Mobile number",
    owner: "Owner",
    no_code_word: "No code word",
    give_us_feedback: "Give us feedback",
    get_started: "Get started",
    later: "Later",
    you: "You",
    someone_else: "Someone else",
    alarm_central: "Alarm central",
    go_back: "Go back",
    more_options: "More options",
    sms: "sms",
    emergency_alarm: "Emergency alarm",
    fire_alarm: "Fire alarm",
    water_alarm: "Water alarm",
    burglary_alarm: "Burglary alarm",
    other: "Other",
    select: "Select",
    webhook: "Webhook",
    how_it_works: "How it works",
    tell_me_more: "Tell me more",
    your_name: "Your name",
    your_phone_number: "Your phone number",
    month: "Month",
    manage: "Manage",
    my_closest_circle: "My closest circle",
    other_groups: "Other groups",
    people: "People",
    invite_recipients: "Invite recipients",
    person: "Person",
    ajax_systems: "Ajax systems",
    delete_recepient: "Delete recepient",
    invitation_sent: "Invitation sent",
    step_n_of_n: "Step {0} of {1}",
    activate_alarmSMS: "Activate AlarmSMS",
    update_payment_card: "Update payment card",
    upgrade_subscription: "Upgrade subscription",
    proceed: "Proceed",
  },
  htmlHeader: {
    title: "Safeland's alarm services",
    desc: "Connect your alarm to selected receivers or choose 24/7 monitoring with an alarm center with guards.",
  },
  placeholder: {
    your_email: "Your email",
    home_name: "Vacation home",
    enter_your_name: "Your name",
    enter_home_address: "Enter your home address",
    webhook_url: "Enter webhook URL",
    request_body: "Enter request body",
    recipients_name: "Enter recepient's name",
    recipients_mobile_number: "Enter recipient's mobile number",
    nominees_name: "The nominee's name",
    phone_number: "+46 000 00 00 00",
    enter_message: "Type a message here",
    anonymous: "I'd like to remain anonymous",
    enter_your_number: "Enter your mobile number",
    enter_your_phone_number: "Enter your phone number",
  },
  feedback: {
    invalid_password: "Password must contain at least 4 characters",
    invalid_email: "Please enter a valid email",
    invalid_credentials: "Invalid credentials",
    invalid_phone: "Enter a valid phone number",
    something_wrong: "Something went wrong",
    forgot_password_success:
      "We've sent you an email to {0} with instructions on how to reset your password. Take a look in your inbox.",
    unmatched_password: "The new password that you entered do not match!",
    hub_added: "Hub: {0} added to connect",
    enter_valid_url:
      'Please, enter a correct webhook URL, for example, "https://example.com" or "http://example.com"',
    enter_valid_JSON: "Please enter valid JSON",
    ua_service: "Requested service in unavailable",
    reset_pass_exp_token:
      "Sorry, but it seems the reset token you're using has expired.",
    invalid_license_key: "Invalid license key",
    empty_fields: "Please fill in all required fields to continue",
    please_enter_your_value: "Please, enter your {0}",
    required_name: "Please, enter your name",
    required_name_and_surname: "Please, enter your name and surname",
    required_email: "Please, enter your email",
    required_phone: "Please, enter your phone",
    required_home: "Please, enter your home's name",
    required_address: "Please, enter your address",
    required_postcode: "Please, enter your postcode",
    required_city: "Please, enter your city",
    required_recipient_name: "Please, enter recipient's name",
    required_recipient_phone_number: "Please, enter recipient's mobile number",
    required_nominees_name: "Enter the nominee's name",
    required_nominees_phone_number: "Enter the nominee's phone number",
    required_nominees_email: "Enter the nominee's email",
    recipient_mobile_number_exist:
      "There is already a recipient with this mobile number",
    phone_already_inuse: "The phone number is already used by another alarm",
    hub_already_inuse:
      "THIS HUB ID IS ALREADY CONNECTED TO SAFELAND. CONTACT SAFELAND IF THIS PERSISTS.",
    required_country: "Choose a country",
  },
  login: {
    footer: "New to safeland?",
  },
  register: {
    footer: "Already have account?",
  },
  forgot_password: {
    btn: "Send Link",
    footer_1: "Log in",
    footer_2: "Safeland account",
  },
  dashboard: {
    card_1_title: "Location of your alarm system",
    card_1_desc:
      "Setting up a brand new connection? Configuring an existing one? Get started or update your settings here.",
    card_1_btn: "Login or register",
    card_2_title: "Connect",
    card_2_desc: "Protect your house and property",
    divider_title: "Connect to Safeland",
    divider_subtitle: "Choose one of our products below",
    divider_subtitle_empty:
      "This account does not currently have a Connect-subscription.",
    login_modal_title: "Log in to your Safeland account",
    register_modal_title: "Register your Safeland account",
    forgot_password_modal_title: "Reset your password",
    device_notconfig_desc:
      "The service is either incomplete or not set up correctly",
    device_missing_card_desc: "Add a banking card for automatic prolongation",
    empty_services_title: "Subscribe to Safeland's alarm services",
  },
  purchase: {
    title: "Purchase alarm services",
    subtitle:
      "Here you can connect your home alarm to one or more of Safeland's alarm services.",
    info_1_aside:
      "alarms to selected recipients in the app and digital neighbourhood watch",
    info_2_aside: "alarms to selected recipients via SMS",
    info_3: "Alarm central with security guards",
    info_4: "Ajax Smart Home integration",
    alarm_conf_para:
      "Do you currently own an alarm that you want to connect to Safeland?",
    alarm_list_title: "Select manufacturer", 
    success_title: "Welcome to Safeland",
    success_desc:
      "Thank you for your subscription. Now, let’s get your alarm connected and running!. You can edit, update and add things whenever you like.",
    alarm_list_footer_title: "Connect alarm using HTTP",
    alarm_list_footer_subtitle:
      "Alarm not in this list? No problem. If your alarm is able to ‘call’ a URL using HTTP, you can connect it to Safeland with a webhook.",
    ua_alarm_modal_desc:
      "This alarm provider is not currently compatible with Safeland Connect. However, if you provide your contact details below, we can get in touch to discuss the best solution for you.",
    plan_modal_title: "Choose your plan",
    plan_modal_subtitle: "Connect Plus - Alarm central with security guards",
    plan_modal_dec:
      "Our alarm central applies the most suitable response when you alarm gets triggered.",
    alarm_pkg_subtitle: "Purchase Safeland's alarm packages",
    alarm_pkg_desc:
      "Kickstart your home security with one of our packages. No complicated conditions or hidden fees. You can easily customise your package, and add extra services and products as you like!",
  },
  service: {
    error_title: "Your service is not working as expected",
    error_desc:
      "In order to get your Connect Homes rolling again, please fix any issues below. If you cannot resolve the issue please contact us at {0}",
    monthly_pay: "Monthly subscription ({0} {1}/monthly)",
    annually_pay: "Annually subscription ({0} {1}/annually)",
    card_1_title: "Alarm location details",
    card_2_title: "Alarm system",
    card_3_title: "Alarm operator",
    card_5_title: "My subscription",
    card_1_btn: "Edit location",
    card_2_btn: "Edit connection details",
    card_3_btn: "Modify alarm operator response",
    card_4_btn: "Add/Edit collaborators",
    card_5_btn: "Update payment method",
    card_5_btn_2: "Cancel service",
    card_2_footer_sms_title: "You need to provide your alarm's phone number",
    card_2_footer_sms_desc:
      "Without the phone number of your alarm we can never know when your alarm is triggered",
    card_2_footer_ajax_title: "You need to provide your alarm's Hub ID",
    card_2_footer_ajax_desc:
      "Without the Hub ID of your alarm we can never know when your alarm is triggered",
    card_4_footer_title: "Did you invite everyone?",
    card_4_footer_title_error:
      "Add recipients by connecting your alarm to groups",
    card_4_footer_desc:
      "Invite more people and remind them to accept the invitations",
    card_4_footer_desc_error:
      "With no recipients Connect cannot communicate with your peers",
    card_4_cont_title: "{0} People in {1} Group",
    card_4_cont_desc: "are recipients of your alarms",
    unconf_title: "Welcome to Safeland",
    unconf_desc: "Set up your services in a few simple steps",
    step_alarm_sms_title: "Set up AlarmSMS",
    step_smhi_title: "Set up Smart Home integration",
    step_location_title: "Set the alarm system's location",
    step_alarm_central_title: "Set instructions for alarm central",
    step_alarm_connection_title: "Link the alarm system to Safeland",
    step_connect_title: "Set up Connect",
    edit_loc_title: "Your home’s location",
    edit_loc_desc:
      "Select an existing home or add a new home where you will use your Safeland Connect service.",
    add_home_item_title: "Add a new home",
    add_home_item_desc: "Add a new home on your preferred location",
    add_home_modal_title: "Your homes information",
    alarm_operator_status_error: "Waiting for ARC confirmation",
    alarm_operator_title: "Connected to Westra Security",
    alarm_operator_footer_title:
      "You need to provide a valid alarm instruction",
    alarm_operator_footer_desc:
      "Without an alarm instruction, the alarm central can not take action when your alarm is triggered",
    alarm_connection_unsupported_btn: "Add another alarm",
    alarm_connection_unsupported_error_title: "Alarm unavailable",
    alarm_connection_unsupported_error_desc:
      "This alarm is no longer supported",
    edit_alarm_connection_title: "Alarm type",
    edit_alarm_connection_config_modal_title:
      "Connect your alarm system to Safeland",
    edit_alarm_connection_desc_1:
      "Now it's time to connect your alarm to Safeland.",
    edit_alarm_connection_desc_2: "Please confirm your alarm model.",
    edit_alarm_connection_btn_1: "Confirm & Continue",
    edit_alarm_connection_btn_2: "Change alarm type",
    edit_alarm_connection_alarms_desc_1:
      "Now it's time to connect your alarm to Safeland.",
    edit_alarm_connection_alarms_desc_2: "Please select your alarm model.",
    edit_alarm_connection_ajax_desc_1:
      "Have you upgraded or wish to change your Ajax hub?",
    edit_alarm_connection_ajax_desc:
      "Select the hub you wish to connect - this will replace your currently connected hub.",
    edit_alarm_connection_ajax_login_desc: "Logged in to Ajax as: {0}",
    edit_alarm_connection_ajax_login_title:
      "Log in to your Ajax account to connect a hub to Safeland",
    edit_alarm_connection_modal_title: "Connect your alarm system to Safeland",
    edit_alarm_connection_login_desc:
      "Log in to your Ajax account to connect a hub to Safeland",
    edit_alarm_connection_hubs_desc:
      "Select the hub - this selection will replace the previous hub",
    edit_payment_info_del_title: "Cancel service?",
    edit_payment_info_del_desc:
      "Are you sure you want to cancel? By cancelling your service, your home will no longer be protected by nearby friends and neighbours. Your service will remain active until {0} as you have paid for the service until this time.",
    edit_payment_info_del_btn: "Yes, i want to cancel",
    payment_info_modal_title: "Register a new credit card",
    payment_info_canceled_desc:
      "You have cancelled your subscription. Please email us with any feedback or if you want to reactivate your subscription.",
    payment_info_canceled_footer_title: "Subscription is cancelled",
    payment_info_canceled_footer_desc: "Your service is valid to {0}",
    payment_activate_footer:
      "Important, update your payment method to prevent the subscription to be terminated at the end of period.",
    payment_invoice_title: "Invoice customer",
    payment_invoice_desc: "Contact {0} to manage data or unsubscribe.",
    payment_desc_cancelled_title: "Subscription canceled",
    payment_desc_cancelled_subtitle: "The service is active until",
    payment_cancelled_title: "Paid until",
    payment_cancelled_missing_card_subtitle:
      "Add payment card to continue service after end date",
    payment_btn_0_missing_card: "Add a payment card",
    payment_btn_0: "Update payment card",
    payment_btn_1: "Cancel now",
    payment_btn_2: "Cancel on the due date",
    payment_btn_3: "Upgrade subscription",
    payment_modal_add_card_missing_card_title: "Register a new payment card",
    payment_modal_add_card_title: "Cancel subscription?",
    payment_modal_cancelled_title: "Cancel subscription?",
    payment_modal_cancelled_subtitle:
      "Are you sure you want to cancel the subscription?",
    payment_add_card_desc:
      "Contact {0} if you prefer payment by a yearly invoice",
    payment_modal_manage_title: "Manage subscription",
    smhi_webhooks_desc:
      "Here you can activate, deactivate and configure external webhooks.",
    smhi_webhook_empty_desc:
      "Safeland can call an external system by a webhook when your alarm system gets triggered.",
    smhi_webhook_desc:
      "Safeland calls this webhook in case an alarm is triggered.",
    alarmSMS_desc: "Fast help from those you trust - simple and effective.",
    alarmSMS_modal_del_title: "Delete AlarmSMS recipient",
    alarmSMS_modal_del_desc: "Are you sure you want to delete {0}?",
    alarmSMS_inactive_subtitle:
      "Offer - free of charge for you with a Connect subscription",
    alarmSMS_inactive_info_title:
      "Help when every second counts - fast and hassle-free",
    alarmSMS_inactive_info_desc:
      "AlarmSMS is an alarm service that sends alarm notifications via SMS to your chosen recipients. They receive a web link, where they can collaborate and stay updated in real time - no app needed.",
    alarmSMS_inactive_info_subtitle_0: "{0} SMS per month included.",
    alarmSMS_intro_title: "Safeland introduces AlarmSMS",
    alarmSMS_intro_terms_desc: "I have read and accept {0} for AlarmSMS",
    alarmSMS_intro_terms_text: "the terms and conditions",
    alarmSMS_term_title: "Specific terms and conditions for AlarmSMS",
    alarmSMS_term_cond_0_title: "Service description",
    alarmSMS_term_cond_0_subtitle:
      "The AlarmSMS service involves sending SMS messages to the telephone numbers designated by the Customer, in accordance with the relevant service description described on the Safeland website.",
    alarmSMS_term_cond_1_title: "Included messages and additions",
    alarmSMS_term_cond_1_subtitle:
      "The service includes thirty (30) SMS messages per calendar month. If all the SMS messages included in a single calendar month are used up, the customer will be charged SEK forty-nine (49), which will result in an additional thirty (30) SMS messages. No SMS messages are saved for the following month.",
    alarmSMS_term_cond_2_title: "Responsibility and approval",
    alarmSMS_term_cond_2_subtitle:
      "The Customer is responsible for ensuring that the telephone numbers provided are correct and that each recipient has given the necessary authorisation to receive SMS messages. The recipient may, on their own initiative, stop receiving further SMS messages, in which case no new SMS messages will be sent to their telephone number.",
    alarmSMS_term_cond_3_title: "Service deactivation",
    alarmSMS_term_cond_3_subtitle:
      "If you do not want you or your recipients to receive AlarmSMS, you need to empty the recipient list.",
    alarmSMS_term_cond_4_title: "Other terms and conditions",
    alarmSMS_term_cond_4_subtitle:
      "The AlarmSMS service is currently temporarily included in the Safeland Connect service. Safeland does not assume any liability with regard to pricing or delivery conditions in the event of a renewal of the service. Safeland's general terms and conditions are available at www.safeland.se/se/villkor.",
    alarmSMS_steps_title: "Activate AlarmSMS - Step {0} of 2",
    alarmSMS_steps_1_1_desc: "Would you like to add yourself as a recipient?",
    alarmSMS_steps_1_2_desc:
      "Add more recipients (you can change the list later).",
    alarmSMS_options_total_desc: "have been sent this month",
    alarmSMS_options_categories_title:
      "Select the alarm types to send to your recipients",
    connect_inactive_subtitle: "Fast help from those you trust most",
    connect_inactive_desc:
      "Connect links your alarm system to your digital collaboration groups. Link the alarm system to your collaboration group in the Safeland app and get the fastest help from people you trust.",
    alarm_central_inactive_subtitle:
      "24/7 security with professional management",
    alarm_central_inactive_desc:
      "The alarm center is there 24/7, which provides peace of mind when you are at work, on vacation or sleeping. You don't have to be available or react yourself.",
  },
  add_home: {
    desc: "Please confirm or add to your home’s address. Be sure to give your home a personal name, too.",
    placeholder_1: "e.g at home, the summer cottage",
    placeholder_2: "Enter  your address",
    error_msg_2:
      "The address is not complete. Search for and select the full address in the list",
    placeholder_3:
      "Please note any additional information that your alarm recipients may need to know if they respond to your triggered alarm. Examples include: Door code, if a dog is present, specific location of front door, etc.",
    add_info_placeholder:
      "i.e Yellow house entrance on the back, access code is 1739. beware of dogs",
  },
  service_verisure: {
    desc: "Connecting your Verisure alarm to Safeland is done in two simple steps. You do this by logging in to your Verisure account on the web.",
    step_1: "Add Safeland's phone number as an alarm recipient",
    step_1_1: "Add Safeland as an SMS recipient: {0}",
    step_1_2: "Purchase SMS credits",
    step_2: "Add your unique identifier",
    step_2_1:
      "Set the code below as the name of your Verisure alarm system. Click the code to copy it.",
  },
  service_webhook: {
    desc_1:
      "Below is the unique webhook for your alarm device. Your alarm will need to call this webhook, using an HTTP POST request, to trigger an alarm in Safeland. Press the webhook to copy it.",
    desc_2:
      "This is the unique webhook for your alarm device. Your alarm will need to call this webhook, using an HTTP POST request, to trigger an alarm in Safeland.",
  },
  service_edit_phone: {
    title: "Add Safeland phone number to your alarm",
    desc_1:
      "If your alarm is tripped, it sends an SMS to a list of phone numbers. This is how Safeland will receive your alarm. Follow your alarm’s instructions and add Safeland as a recipient",
    desc_2:
      "Follow your alarm’s instructions and add Safeland as a recipient. Our number is:",
    condition: "I confirm I have added Safeland number as an alarm recipient",
    number_modal_title: "Alarm phone number",
    number_modal_desc:
      "Enter the phone number of your alarm. This is your unique identifier, and how we know the alarm belongs to you.",
  },
  service_edit_alarm_operator: {
    summary: "Summary",
    step1_title: "Customer information",
    step1_desc:
      "Complete your details below - this will be shared with your alarm operator. Code word is optional and, if entered, will be requested by the alarm operator.",
    contacts_title: "Nominated call list",
    contacts_desc:
      "Below you can nominate people who you’d like your Alarm Operator to call when your alarm is triggered. Code words are optional and, if entered, will be requested by the alarm operator.",
    contacts_form_title: "Add nominee",
    contacts_form_desc: "Complete the form below and click ‘Add’",
    contacts_admin_desc:
      "Nominees with admin authority has full access to modify alarm operator customizations.",
    contacts_table_title: "Nominated call list",
    contacts_del_modal_title: "Remove contact person",
    actions_title: "Select the alarm types to send to your recipients",
    actions_desc_1:
      "You can decide what action the alarm operator should take in the following alarm scenarios.",
    actions_desc_2:
      "Note: Sending a guard will be invoiced with 2100 SEK if crime could not be verified.",
    actions_option_1: "No action",
    actions_option_2: "Send guards to property",
    actions_option_3:
      "Contact nominees during the day. Other times and times where there is no response, control given to guards",
    actions_option_4:
      "Contact nominees at any time. If no response, control given to guards",
    actions_option_5: "Contact nominees at any time. No further action.",
    summary_detail_1_title: "The alarm operator and the Safeland app",
    summary_detail_1_desc:
      "Larmcentralen kan inte ta del av dina grannars samverkanskommunikation i Safeland-appen.",
    summary_detail_2_title: "Security Guard Services fees",
    summary_detail_2_desc:
      "If you are utilising the security guard service as part of your action plan outlined above, a fee of 2100SEK, including VAT, will be issued each time security guards are called out to your home. An invoice will be sent to your specified email address and carry a 20 day payment term. In cases where a burglary attempt to your home has been confirmed, the ‘call out’ fee is waived. The proof of a burglary attempt can be strengthened by the presence of a police report. The alarm operator service is a consumer product. Business customers will be charged an additional 490SEK per year.",
    summary_detail_3_title:
      "Management of your information and general conditions",
    summary_detail_3_desc:
      "Your security service allows Safeland and subcontractors to have access to personal information. This personal information consists of the information given above, as well as the information generated by the Safeland service and associated home alarm. This information is necessary to deliver the service to you, the Customer, as well as to meet requirements alarm operators must comply with as part of the current standard. If guards are required to be dispatched, the relevant information described in this document will be issued to the guard company.",
  },
  service_edit_collaborators: {
    desc: "Choose who receives your alarm if it's triggered. I.e. friends, neighbours, and family members.",
    count_desc_1: "You currently have",
    count_desc_2: "able to receive your alarm",
    invite_title_placeholder: "{0}'s home alarm group",
    invite_desc:
      "The most important people, such as your family, closest friends, or neighbours that should receive alarms.",
    invite_btn: "Invite more people",
    invite_btn_2: "Create new group",
    invite_footer: "{0} pending invitations",
    invite_footer_placeholder: "No one has been invited yet",
    group_title: "Connect to Safeland-groups",
    group_empty_desc_1:
      "Safeland plays host to all kinds of local, safety-related groups, such as Neighbourhood Watch groups, local police-led groups or community support groups.",
    group_empty_desc_2:
      "If you're a member of these groups, you can request your home alarm to be shared with those members, too. When you have finished setting up your alarm, be sure to discover what groups exist around you!",
    group_desc:
      "Link your alarm to more groups that you are a member of, such as the local neighbourhood watch group.",
    group_btn: "Select groups",
    group_footer:
      "Tip: you can find and join existing groups in the Safeland app",
    actions_desc:
      "Select the alarm types that you wish to be forwarded to your groups in Safeland",
    hook_title: "Smart Home Integration (Beta)",
    hook_desc:
      "Safeland can call a remote service using a webhook when your alarm is triggered.",
    hook_btn: "Configure webhook",
    invite_modal_title: "Invite people via email",
    invite_modal_desc:
      "Invite people directly to be collaborators of your alarm.",
    invite_modal_input_label: `Add one or multiple email addresses (Separate them with a "Space" or "Enter").`,
    invite_modal_input_placeholder: "Enter your email(s)",
    invite_modal_btn: "Send invitations",
    group_modal_title: "Connect to existing Safeland-groups",
    group_modal_desc:
      "Link your alarm to more groups that you are a member of, such as the local neighbourhood watch group.",
    webhook_modal_title: "Call an external webhook",
    webhook_modal_desc:
      "Safeland can call an external webhook when your alarm is triggered. Enter data below to setup the webhook request.",
    webhook_del_title: "Delete the external webhook",
    webhook_del_desc: "Are you sure that you want to delete the webhook?",
    webhook_test_title: "Test your webhook configuration",
    webhook_test_desc:
      "Press the Send button to send a test request to the webhook.",
    new_group_modal_title: "Create a new group",
  },
  not_found: {
    title: "404",
    desc: "Page not found",
  },
  activate: {
    header_title: "Activate your service",
    footer_desc: "Service already activated!",
    unauth_title: "Start activation",
    unauth_desc:
      "To get started, please log into your Safeland account or create a new account.",
    error: "Something seems wrong with your license",
    success_title: "Activation successful!",
    success_desc:
      "Your Connect service is now activated and ready to be used! Now, connect your home alarm to your Connect subscription.",
    success_btn: "Configure alarm",
    invalid_title: "Enter your activation code",
    invalid_desc:
      "To activate your service, enter your unique activation code below.",
  },
  reset_password: {
    title: "Choose a new password",
    desc: "You're almost there! Enter your new password below to reset the password for your account associated with",
    btn: "Reset my password",
    invalid_link_title: "Invalid Reset Password Link",
    invalid_link_desc:
      "Uh-oh! It looks like the reset password link you clicked on is no longer valid. Please double-check the link and try again.",
    success_feedback: "Password has been successfully updated for {0}.",
  },
  authentication: {
    title: "Safeland's alarm services",
    info_0_title: "Connect",
    info_0_desc:
      "Alarms to selected recipients and digital neighbourhood watch",
    info_1_title: "Alarm central with security guards",
    info_1_desc: "24/7 monitoring with professional management",
    info_2_title: "AlarmSMS",
    info_2_desc: "Alarms to selected recipients via SMS",
    info_3_title: "Smart Home integration",
    info_3_desc: "Integrate the alarm with your smart home",
  },
  feedback_page: {
    title: "Give us feedback",
    desc_0: "Is there anything we can do better? Is anything missing?",
    desc_1:
      "Please, share your thoughts with us so we can make the service even better!",
    success_title: "Thank you for your opinion!",
    success_desc:
      "We are constantly working to improve our services and are grateful that you have taken the time to make your voice heard.",
  },
  unsupported_device: {
    default_title: "For you with Selected Alarm",
    default_description:
      "Unfortunately, it is not possible to use selected Alarm for Safeland's alarm services.",
    info: "If you are thinking about ending your subscription – take the opportunity to try Safeland's home alarm. You get an {0}, {1}  that you own yourself, with {2} and {3}.",
    info_highligh_0: "easy-to-use",
    info_highligh_1: "high-tech system",
    info_highligh_2: "lower costs",
    info_highligh_3: "smart alarm services",
    btn_0: "To home alarms",
    contact_modal_title: "Would you like to know more?",
    contact_desc:
      "Leave your phone number and we will call you and tell you more about our offer.",
  },
  configure_device: {
    http_title: "Alarm with connection via HTTP",
    http_description:
      "It is possible to connect any alarms that support webhooks, for example:",
    http_description_ex_0: "Nest Protect",
    http_description_ex_1: "Minut Point",
    sms_title: "Alarm with connection via SMS",
    sms_description:
      "It is possible to connect all alarms that support connection via SMS.",
    other_subheading: "Is your alarm not listed?",
    other_description: "Contact us if you want to modify the alarm connection.",
  },
  subscription_plans: {
    title: "Select a subscription plan",
    proration_ok_text: "Pay {0} kr now",
    proration_desc_0:
      "Your current subscription will be terminated and you will be refunded {0} kr",
    proration_desc_1:
      "After that, your subscription to {0} will start and you will be charged {1} kr.",
    payment_failed_desc: "Payment failed. Please update your payment card.",
    upgrade_successful_desc:
      "Congratulations! Your subscription has been upgraded to {0}.",
  },
  api: {
    services: {
      devices: {
        terms:
          "Congratulations! It is now possible to connect your Verisure alarm to Safeland. You can connect both active and cancelled Verisure alarms.\n\nSafeland connects your alarm to neighbourhood watch and saves you money yearly on alarm central and security guards.",
      },
      devicePackages: {
        premiumlarmet_btn_0: "Read more and purchase",
        premiumlarmet_title: "Safeland's popular home alarms",
        folklarmet_desc:
          "An impressive home alarm kit that doesn’t cost the earth. The Sikkerthjem S6evo is great value for money and contains all the fundamental components that a modern home alarm system needs.",
        premiumlarmet_desc:
          "The safe card for those who want a very good home alarm - regardless of the housing type.",
      },
      paymentPlans: {
        basic_infos: ["Connect", "AlarmSMS", "Smart Home integration"],
        plus_infos: [
          "Connect",
          "AlarmSMS",
          "Smart Home integration",
          "Certified alarm central 24/7",
          "Access to security guards",
        ],
      },
    },
  },
};
